import React from "react";
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Footer from "components/Footer/Footer.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import bgImg from "assets/background-image/earth.jpg";
const useStyles = makeStyles(styles);


export default function AuthLayout(props) {
  const { ...rest } = props;
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    return ()=> {};
  }, []);

  return (
   <div>
    <div className={classes.wrapper}>
      <div
        className={classes.fullPage}
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <Outlet /> 
        <Footer white />
      </div>
    </div>
  </div>
  );
}